import React, { useEffect, useState } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material UI
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

// Helpers
import { returnDateAndTime } from 'helpers/date';

// Components
import { TablePlaceholder } from 'components/TablePlaceholder';
import { LineSkeleton } from 'components/LineSkeleton';
import { TableHistoryDatails } from '../LoteDatails/components/SubmissionHistory/components';

// Contants
import IMAGES from 'constants/images';
import REPORTS from 'constants/report';
import { REPORTS_TYPES } from 'constants/report';

// Actions
import { setOpen } from 'store/ducks/dialogs/actions';
import * as ReportActions from 'store/ducks/reports/actions';
import * as UsersActions from 'store/ducks/users/actions';

// Types
import { ApplicationState } from 'store';
import {
  ScheduleInterface,
  ReportScheduleHistoriesInterface,
} from 'store/ducks/reports/types';

// styles
import useStyles from './History.styles';

interface HistoryProps {
  reportType: string;
  secondReportType?: string;
}

type Props = HistoryProps;

const History: React.FC<Props> = ({ reportType, secondReportType }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [tableIsVisible, setTableIsVisible] = useState(false);
  const [opemDialog, setOpemDialog] = useState(false);
  const [schedules, setSchedules] = useState<ScheduleInterface[]>([]);
  const [currentSchedule, setCurrentSchedule] = useState<
    ReportScheduleHistoriesInterface
  >();
  const [
    reportEntry,
    setReportEntry,
  ] = useState<ReportScheduleHistoriesInterface | null>();
  const [scheduleHistory, setScheduleHistory] = useState<
    (ReportScheduleHistoriesInterface | undefined)[]
  >([]);

  const scheduleData = useSelector(
    (state: ApplicationState) => state.reports.scheduleData,
  );
  const isLoading = useSelector(
    (state: ApplicationState) => state.reports.loading,
  );
  const scheduleList = useSelector(
    (state: ApplicationState) => state.reports.scheduleList,
  );

  const secondScheduleList = useSelector(
    (state: ApplicationState) => state.reports.secondScheduleList,
  );

  const handleLoadTable = () => {
    setTableIsVisible(true);

    // dispatch();
  };

  const handleDialog = (schedule: ReportScheduleHistoriesInterface) => {
    dispatch(
      setOpen({
        open: true,
        maxWidth: 'lg',
        content: (
          <TableHistoryDatails
            setReportEntry={setReportEntry}
            scheduleData={schedule}
            submissionData={scheduleData}
            reportEntry={reportEntry!}
          />
        ),
      }),
    );
  };

  const getFilter = (schedule: ScheduleInterface) => {
    let aux = '';
    Object.keys(schedule.filters).forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  const getTimeCourse = (schedule: ScheduleInterface) => {
    const result = Math.ceil(schedule.dataInterval / 86400000);
    return result;
  };

  const getGroupings = (schedule: ScheduleInterface) => {
    let aux = '';
    schedule.groupings.forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  useEffect(() => {
    dispatch(
      ReportActions.scheduleListRequest({
        id: currentSchedule?.reportScheduleId,
      }),
    );
  }, [currentSchedule]);

  useEffect(() => {
    if (!reportEntry) {
      dispatch(
        ReportActions.scheduleListRequest({
          reportType,
          _includes: 'history',
        }),
      );
    }
  }, [reportEntry]);

  useEffect(() => {
    if (secondReportType && !reportEntry) {
      dispatch(
        ReportActions.secondScheduleListRequest({
          reportType: secondReportType,
          _includes: 'history',
        }),
      );
    }
  }, [reportEntry]);

  useEffect(() => {
    setSchedules([...scheduleList, ...secondScheduleList]);
  }, [scheduleList, secondScheduleList]);

  useEffect(() => {
    setScheduleHistory(
      schedules
        .map(({ ReportScheduleHistories }) => ReportScheduleHistories)
        .flatMap((item) => item),
    );
  }, [schedules]);

  useEffect(() => {
    if (scheduleData.reportType) {
      if (
        scheduleData.reportType === REPORTS_TYPES.ENTRY_VALUE_SIMPLIFIED ||
        scheduleData.reportType === REPORTS_TYPES.ENTRY_VALUE
      ) {
        setReportEntry(currentSchedule);
      } else {
        if (currentSchedule) handleDialog(currentSchedule!);
      }
    }
  }, [scheduleData]);

  useEffect(() => {
    dispatch(
      UsersActions.listWebUsersRequest({
        body: {
          _includes: 'operators',
          _limit: 9999,
        },
      }),
    );
  }, []);

  return (
    <Box m={2}>
      {!tableIsVisible && <TablePlaceholder onClick={handleLoadTable} />}
      {tableIsVisible &&
        (!reportEntry ? (
          <TableContainer className={classes.table}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Envio</TableCell>
                  <TableCell>Recorrência</TableCell>
                  <TableCell>Filtros</TableCell>
                  <TableCell>Agrupamentos</TableCell>
                  <TableCell>Destinatários</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!isLoading ? (
                  <>
                    {!!scheduleHistory?.length ? (
                      scheduleHistory.map((schedule: any, index: number) => (
                        <TableRow>
                          <TableCell>
                            {returnDateAndTime(schedule.createdAt)}
                          </TableCell>
                          <TableCell>
                            {getTimeCourse(schedule) > 1
                              ? 'Últimos ' + getTimeCourse(schedule) + ' dias'
                              : 'Último ' + getTimeCourse(schedule) + ' dia'}
                          </TableCell>
                          <TableCell>{getFilter(schedule)}</TableCell>
                          <TableCell>{getGroupings(schedule)}</TableCell>
                          <TableCell>{schedule.supervisorIds.length}</TableCell>
                          <TableCell>
                            <Box
                              display='flex'
                              alignItems='center'
                              justifyContent='space-between'
                              maxWidth='128px'>
                              <IconButton>
                                <img
                                  src={IMAGES.REPORTS_ICONS.DOWNLOAD}
                                  alt='download'
                                />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setCurrentSchedule(schedule);
                                }}>
                                <img
                                  src={IMAGES.REPORTS_ICONS.OPEN_REPORTS}
                                  alt='download'
                                />
                              </IconButton>
                              <IconButton>
                                <img
                                  src={IMAGES.REPORTS_ICONS.SEND_MENSSAGE}
                                  alt='download'
                                />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell />

                        <TableCell />
                      </TableRow>
                    )}
                  </>
                ) : (
                  <>
                    <TableRow>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableHistoryDatails
            setReportEntry={setReportEntry}
            scheduleData={currentSchedule!}
            submissionData={scheduleData}
            reportEntry={reportEntry}
          />
        ))}
    </Box>
  );
};

export { History };
export default History;
